import React from 'react';
import {useQuery} from "@tanstack/react-query";
import bosService from "../../../../../../services/web/bos-service.js";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";

const AssociationRenderer = ({data: {hasbos, hasencounter,hasoccurrence, hassos}}) => {
    const {data: boName} = useQuery({
        queryKey: ['boName'],
        queryFn: () => bosService.getBoName(),
        initialData: 'BO'
    });

    return (
        <span className={"text-[#676a6c]! font-bold! info flex items-center h-full"}>
            {hasbos && <img title={`Associado à ${hasbos} ${boName}(s)`} className={"w-5.25"} src={getAssetPath(`/img/dashboard-svg/sw.bogcm.svg`)} alt="image"/>}
            {hasoccurrence && <img title={`Associado à ${hasoccurrence} ocorrência(s)`} className={"w-5.25"} src={getAssetPath(`img/dashboard-svg/sw.occurrence.svg`)} alt="image"/>}
            {hasencounter && <img title={`Associado à ${hasencounter} abordagem(s)`} className={"w-5.25"} src={getAssetPath(`/img/dashboard-svg/sw.approach.svg`)} alt="image"/>}
            {hassos && <img title={`Associado à ${hassos} SOS(s)`} className={"w-5.25"} src={getAssetPath(`/img/dashboard-svg/sw.sos.svg`)} alt="image"/>}
        </span>
    )
};

export default AssociationRenderer;